import React, { useEffect } from 'react'
import { useUnit } from 'effector-react'
import { $multiCount, multiCountMounted } from './model'
import { CCardBody, CCol, CRow } from '@coreui/react-pro'
import { useNavigate } from 'react-router-dom'
import { $params } from '../../../../../../features/router'

export const Instalments: React.FC = () => {
  const multiCount = useUnit($multiCount)
  const navigate = useNavigate()
  const paramState = $params.getState()

  useEffect(() => {
    multiCountMounted()
  }, [])

  const handleClick = (status: string) => {
    navigate('/instalments', {
      state: { status, userId: paramState?.clientID },
    })
  }

  if (!multiCount) {
    return <div>No data</div>
  }

  return (
    <CCardBody>
      <CRow className="mb-1">
        <CCol>
          <strong>Active: </strong>
          <span
            className="link-primary"
            role="button"
            onClick={() => handleClick('in_progress')}
          >
            {multiCount?.count.active}
          </span>
        </CCol>
      </CRow>
      <CRow className="mb-1">
        <CCol>
          <strong>Completed: </strong>
          <span
            className="link-primary"
            role="button"
            onClick={() => handleClick('completed')}
          >
            {multiCount?.count.completed}
          </span>
        </CCol>
      </CRow>
      <CRow className="mb-1">
        <CCol>
          <strong>Canceled: </strong>
          <span
            className="link-primary"
            role="button"
            onClick={() => handleClick('cancelled')}
          >
            {multiCount?.count.canceled}
          </span>
        </CCol>
      </CRow>
    </CCardBody>
  )
}
